import { Divider as FluentDivider } from '@fluentui/react-components';
import type { FC } from 'react';
import React from 'react';

import { useClassNameAndInlineStyles } from './Divider.styles';
import type { DividerProps } from './Divider.types';

export const Divider: FC<DividerProps> = ({
  height,
  padding,
  verticalPadding,
  horizontalPadding,
  paddingTop,
  paddingRight,
  paddingBottom,
  paddingLeft,
  ...props
}) => {
  const styling = useClassNameAndInlineStyles({
    height,
    padding,
    verticalPadding,
    horizontalPadding,
    paddingTop,
    paddingRight,
    paddingBottom,
    paddingLeft,
  });

  return <FluentDivider {...props} className={styling.className} style={styling.inlineStyles} />;
};
